var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTWMergeContext } from '@marketing/TWMergeContext';
import { clsx } from 'clsx';
import { useState } from 'react';
function Image(_a) {
    var metadata = _a.metadata, index = _a.index, _b = _a.className, className = _b === void 0 ? '' : _b;
    var _c = useState(false), isLoaded = _c[0], setIsLoaded = _c[1];
    return (_jsx("img", { loading: "lazy", onLoad: function () {
            setIsLoaded(true);
        }, src: metadata.src, className: clsx(isLoaded ? 'opacity-100' : 'opacity-0', 'object-cover h-full md:w-full', 'transition-opacity duration-300 ease-in-out opacity-0', className) }, "image-".concat(index)));
}
function Collage(_a) {
    var images = _a.images, imageStyles = _a.imageStyles;
    var twMerge = useTWMergeContext().twMerge;
    return (_jsxs("div", __assign({ className: "grid grid-rows-[minmax(50px,1fr)_minmax(50px,1fr)] grid-cols-[minmax(90px,18fr)_minmax(50px,10fr)] h-full w-full justify-start items-stretch gap-2xs-m md:gap-y-xs-m md:gap-x-md-m" }, { children: [_jsx("div", __assign({ className: "flex col-start-1 col-end-2 row-start-1 row-end-3 columns-1 justify-center items-center h-full w-full" }, { children: _jsx(Image, { metadata: images[0], index: 0, className: twMerge('rounded-md', imageStyles) }) })), _jsx("div", __assign({ className: "flex col-start-2 col-end-3 row-start-1 row-end-2 justify-end items-center h-full w-full" }, { children: _jsx(Image, { metadata: images[1], index: 1, className: twMerge('rounded-md', imageStyles) }) })), _jsx("div", __assign({ className: "flex col-start-2 col-end-3 row-start-2 row-end-3 justify-end items-center h-full w-full" }, { children: _jsx(Image, { metadata: images[2], index: 2, className: twMerge('rounded-md', imageStyles) }) }))] })));
}
export default Collage;
